var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "#DCDEE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6498 14.8249L14.9998 16.2499L19.4249 20.075L18.8249 20.675L14.3249 16.8499H10.4249L5.92488 20.675L5.32488 20.075L9.75 16.2499L8.1 14.8249L5.25 12.4249V8.29976L3 10.2498V20.7498C3 21.5748 3.675 22.2498 4.5 22.2498H20.25C21.075 22.2498 21.75 21.5748 21.75 20.7498V10.2498L19.5 8.29976V12.4249L16.6498 14.8249ZM9.82464 4.25L12.3746 2L14.9246 4.25H9.82464ZM6.74976 5C6.29976 5 5.99976 5.3 5.99976 5.75V11.9L10.7249 15.8749H14.0249L18.75 11.9V5.75C18.75 5.3 18.375 5 18 5H6.74976Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpened);
export default __webpack_public_path__ + "static/media/opened.4d86ef3ecaca82eb3de4f8e783c0a5bb.svg";
export { ForwardRef as ReactComponent };